import React from 'react';
import classnames from 'classnames';
import { useSingleEffect } from 'react-haiku';

import Show from 'components/Show';
import Icon from 'components/Misc/Icon';
import { useNotificationStore } from 'store/useNotificationStore';

const Notification = ({ notification }) => {
	// Use notification store
	const removeNotification = useNotificationStore(state => state.removeNotification);

	// Remove notification after x seconds
	useSingleEffect(() => {
		setTimeout(() => removeNotification(notification.id), 3300);
	});

	// Concat classnames based on type
	const cls = classnames(
		'mt-4 py-3 px-4 w-full flex items-center rounded-lg overflow-hidden text-white',
		notification.type === 'success' && 'bg-emerald-500',
		notification.type === 'invalid' && 'bg-amber-500',
		notification.type === 'warning' && 'bg-red-500',
	);

	return (
		<div className={cls}>
			<Show if={notification.type === 'success'}>
				<Icon icon="check" className="text-xl" />
			</Show>

			<Show if={notification.type === 'invalid'}>
				<Icon icon="info" />
			</Show>

			<Show if={notification.type === 'warning'}>
				<Icon icon="warning" />
			</Show>

			<div className="ml-3 text-base">{notification.message}</div>
		</div>
	);
};

export default Notification;